import { Component, ElementRef, Inject, Injector, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from '../../../../services/AppComponentBase';
import { showScannerTrialInfoImagesModal } from '../ScannerTrialInfoImages/show-ScannerTrialInfoImages-modal';
import { ScannerNotificationComponent } from '../scanner-notification/scanner-notification.component';
import { QuotePanelsTabsList } from '../../../../enums/QuotePanelsTabs.list';
import {ScannerTrialPopup} from '../ScannerTrialPopup/ScannerTrialPopupModal.component';




@Component({
    selector: "modal-ScannerTrialPopup-mobile",
    template: require('./ScannerTrialPopupMobile.component.html'),
    styles: [require('./ScannerTrialPopupMobile.component.css')]
})

export class ScannerTrialPopupMobile extends ScannerTrialPopup
 {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector, activeModal);

    }

  
}


